// @flow
import React from 'react';
import { SystemAdminNonAdminStatusLabel } from '@components/common/SystemAdminNonAdminStatusLabel';
import { StyledSpan } from '@src/common-utils/styledComponents';

import { getIfCCRowIsAdminEdited, getIfGivenRowIsANewlyAddedRowForEstimateCC } from './utils';

export const EstimateCommittedCapacityRibbonContainer = ({ row }) => {
  if (getIfGivenRowIsANewlyAddedRowForEstimateCC(row)) {
    return null;
  }

  return (
    <StyledSpan
      style={{
        marginLeft: '-2.5rem',
        marginTop: '0.5rem',
        position: 'absolute',
      }}
    >
      <SystemAdminNonAdminStatusLabel isAddedByAdmin={getIfCCRowIsAdminEdited(row)} />
    </StyledSpan>
  );
};
